import React, { useState, useEffect } from 'react';
import { useParams, useNavigate } from 'react-router-dom';
import axios from 'axios';
import api from '../../api';
import { toast } from 'react-toastify';
import {
  Check,
  X,
  Edit2,
  Camera,
  VenetianMask,
  Home,
  CalendarCheck,
  DollarSign,
  Database,
  PlusCircle,
  RefreshCw,
  Settings,
  Key,
  ChevronRight,
  ArrowLeft,
  User,
  Phone,
  Mail,
  CreditCard,
  Briefcase,
  FileText,
  Trash2,
  Users,
  Clock,
  Calendar,
  Lock,
} from "lucide-react";


// Global Axios configuration
axios.defaults.headers.common['Accept'] = 'application/json';

export default function EmployeeDetail() {
  const { empId } = useParams();
  const navigate = useNavigate();

  const [emp, setEmp] = useState(null);
  const [modulesList, setModulesList] = useState([]);
  const [isEditing, setIsEditing] = useState(false);
  const [formData, setFormData] = useState({});
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);
  const [newPhoto, setNewPhoto] = useState(null);
    const [email, setEmail] = useState(null);


  // Password reset form state
const [showPasswordForm, setShowPasswordForm] = useState(false);
const [passwordData, setPasswordData] = useState({
  current_password: '',
  new_password: '',
  confirm_password: '',
});

const handlePasswordChange = e => {
  const { name, value } = e.target;
  setPasswordData(prev => ({ ...prev, [name]: value }));
};

const handlePasswordSave = () => {
  if (!passwordData.new_password) {
    toast.error('Veuillez saisir le nouveau mot de passe');
    return;
  }






  api.post(
    `/utilisateurs/${emp.utilisateur_id}`,
    { 
      mote_de_passe: passwordData.new_password 
    }
  )
  .then(res => {
    console.log('Réponse API update user →', res.data);
    toast.success('Mot de passe mis à jour');
    setShowPasswordForm(false);
    setPasswordData({ current_password: '', new_password: '', confirm_password: '' });
    fetchEmployee();
  })
  .catch(err => {
    console.error('Erreur update user →', err.response || err);
    if (err.response?.status === 422) {
      Object.values(err.response.data.errors || {}).flat()
        .forEach(msg => toast.error(msg));
    } else {
      toast.error('Erreur lors de la réinitialisation');
    }
  });
};





  // Fetch modules list
  useEffect(() => {
    api.get('/modules')
      .then(res => setModulesList(res.data.modules || res.data))
      .catch(err => {
        console.error('Error loading modules →', err);
        toast.error('Unable to load teams');
      });
  }, []);

  // Fetch employee details
  // useEffect(() => {
  //   axios.get(`https://easytask.easysystem.cloud/api/easy-tasks-b/api/utilisateurs/${empId}`)
  //     .then(res => {
  //       const data = res.data.utilisateur || res.data.data || res.data;
  //       setEmp(data);
  //     })
  //     .catch(err => {
  //       console.error(err);
  //       setError('Error retrieving data');
  //     })
  //     .finally(() => setLoading(false));
  // }, [empId]);

  // Au-dessus de tes useEffects
const fetchEmployee = () => {
  setLoading(true);
  api.get(`/utilisateurs/${empId}`)
    .then(res => {
      // Selon ta réponse, ajuste cette ligne :
      const data = res.data.utilisateur || res.data.data || res.data;
      setEmp(data);
      // initialise aussi formData pour les valeurs par défaut
      setFormData({
        nom: data.nom || '',
        prenom: data.prenom || '',
        // …les autres champs
        module_id: data.module_id || '',
      });
    })
    .catch(err => {
      console.error(err);
      setError('Error retrieving data');
    })
    .finally(() => setLoading(false));
};

useEffect(fetchEmployee, [empId]);


  // Update form data when employee data changes
  useEffect(() => {
    if (!emp) return;
    setFormData({
      nom: emp.nom || '',
      prenom: emp.prenom || '',
      cin: emp.cin || '',
      date_naissance: emp.date_naissance || '',
      email: emp.email || '',
      telephone: emp.telephone || '',
      adresse: emp.adresse || '',
      sexe: emp.sexe || '',
      login: emp.login || '',
      date_d_embauche: emp.date_d_embauche || '',
      type_contrat: emp.type_contrat || '',
      rib: emp.rib || '',
      module_id: emp.module_id || '',
    });
  }, [emp]);

  const handleChange = e => {
    const { name, value } = e.target;
    setFormData(prev => ({ ...prev, [name]: value }));
  };

  const handleEdit = () => setIsEditing(true);

  const handleCancel = () => {
    if (!emp) return;
    setFormData({
      nom: emp.nom || '',
      prenom: emp.prenom || '',
      cin: emp.cin || '',
      date_naissance: emp.date_naissance || '',
      email: emp.email || '',
      telephone: emp.telephone || '',
      adresse: emp.adresse || '',
      sexe: emp.sexe || '',
      login: emp.login || '',
      date_d_embauche: emp.date_d_embauche || '',
      type_contrat: emp.type_contrat || '',
      rib: emp.rib || '',
      module_id: emp.module_id || '',

    });
    setIsEditing(false);
  };

    const handlePhotoSelect = (e) => {
  const file = e.target.files[0];
  if (file) setNewPhoto(file);
};


const uploadToLaravel = async (file) => {
  const formData = new FormData();
  formData.append('file', file);

  const res = await api.post('/upload', formData, {
    headers: {
      'Content-Type': 'multipart/form-data',
    },
  });

  return res.data.url; // URL publique renvoyée par Laravel
};

  // const handleSave = () => {
  //   const payload = {};
  //   Object.keys(formData).forEach(key => {
  //     const original = emp[key] ?? '';
  //     const current = formData[key];
  //     if (current !== original) {
  //       payload[key] = key === 'module_id'
  //         ? (current ? parseInt(current, 10) : null)
  //         : current;
  //     }
  //   });

  //   if (Object.keys(payload).length === 0) {
  //     toast.info('No changes detected');
  //     setIsEditing(false);
  //     return;
  //   }

  //   axios.post(`https://easytask.easysystem.cloud/api/easy-tasks-b/api/utilisateurs/${emp.utilisateur_id}`, payload)
  //     .then(res => {
  //       setEmp(res.data.utilisateur);
  //       fetchEmployee();
  //       toast.success('Employee updated successfully');
  //       setIsEditing(false);
  //     })
  //     .catch(err => {
  //       if (err.response?.status === 422) {
  //         Object.values(err.response.data.errors || {}).flat().forEach(msg => toast.error(msg));
  //       } else {
  //         toast.error('Error updating employee');
  //         console.error(err);
  //       }
  //     });
  // };
      useEffect(() => {
    const fetchUser = async () => {
      try {
        const userResponse = await api.get('/me', { withCredentials: true });
        if (!userResponse.data.success) {
          console.error('Impossible de récupérer les informations utilisateur.');
          return;
        }

        const user = userResponse.data.user;
        setEmail(user.email);
      } catch (error) {
        console.error('Erreur lors de la récupération des informations utilisateur.');
      }
    };

    fetchUser();
  }, []);
  const handleForgotPassword = () => {
  if (!emp?.email) {
    toast.error("Email utilisateur introuvable");
    return;
  }

  api.post('/forgot-password', { email: emp.email,  admin_email:email})
    .then(res => {
      toast.success(res.data.message || "Email envoyé à l'administrateur");
    })
    .catch(err => {
      console.error(err);
      toast.error("Erreur lors de l'envoi de l'email");
    });
};

  const handleSave = async () => {
  const payload = {};
  Object.keys(formData).forEach(key => {
    const original = emp[key] ?? '';
    const current = formData[key];
    if (current !== original) {
      payload[key] = key === 'module_id'
        ? (current ? parseInt(current, 10) : null)
        : current;
    }
  });

  try {
    if (newPhoto) {
      const photoUrl = await uploadToLaravel(newPhoto);
      payload.photo = photoUrl;
    }

    if (Object.keys(payload).length === 0) {
      toast.info('Aucune modification détectée');
      setIsEditing(false);
      return;
    }

    const res = await api.post(`/utilisateurs/${emp.utilisateur_id}`, payload);
    setEmp(res.data.utilisateur);
    fetchEmployee();
    toast.success('Employé mis à jour avec succès');
    setIsEditing(false);
    setNewPhoto(null); // Réinitialiser la photo sélectionnée
  } catch (err) {
    if (err.response?.status === 422) {
      Object.values(err.response.data.errors || {}).flat().forEach(msg => toast.error(msg));
    } else {
      toast.error('Erreur lors de la mise à jour');
      console.error(err);
    }
  }
};


  if (loading) {
    return (
      <div className="flex justify-center items-center h-screen">
        <div className="animate-spin rounded-full h-12 w-12 border-t-2 border-b-2 border-terrecuite"></div>
      </div>
    );
  }

  if (error) {
    return <p className="p-4 text-red-600">{error}</p>;
  }

  const fieldIcons = {
    'Créé le': Clock,
    'Mis à jour le': Clock,
    'Supprimé le': Trash2,
  };

  return (
    <div className="w-full min-h-screen bg-gray-50">
      {/* Header Section */}
      <div className="bg-white shadow-sm">
        <div className="container mx-auto px-4 py-4 flex items-center justify-between">
          <button
            onClick={() => navigate(-1)}
            className="flex items-center text-terrecuite hover:text-terrecuite/80 transition-colors duration-200"
          >
            <ArrowLeft className="h-5 w-5 mr-2" />
            <span className="font-medium">Retour</span>
          </button>
          
          {/* Edit / Save / Cancel */}
          <div className="flex items-center space-x-3">
            {isEditing ? (
              <>
                <button
                  onClick={handleSave}
                  className="flex items-center px-4 py-2 bg-green-600 text-white rounded-lg hover:bg-green-700 transition shadow-md"
                >
                  <Check className="h-5 w-5 mr-2" />
                  <span className="font-medium">Enregistrer</span>
                </button>
                <button
                  onClick={handleCancel}
                  className="flex items-center px-4 py-2 bg-gray-100 text-gray-700 rounded-lg hover:bg-gray-200 transition shadow-sm"
                >
                  <X className="h-5 w-5 mr-2" />
                  <span className="font-medium">Annuler</span>
                </button>
              </>
            ) : (
              <button
                onClick={handleEdit}
                className="flex items-center px-4 py-2 bg-blue-600 text-white rounded-lg hover:bg-blue-700 transition shadow-md"
              >
                <Edit2 className="h-5 w-5 mr-2" />
                <span className="font-medium">Modifier</span>
              </button>
            )}
          </div>
        </div>
  
        {/* Profile Header */}
        <div className="container mx-auto px-4 py-6">
          <div className="flex flex-col md:flex-row items-start md:items-center gap-6">
<div className="relative group">
  {emp.photo ? (
    <img
      src={emp.photo.startsWith('http') ? emp.photo : `http://127.0.0.1:8000/storage/${emp.photo}`}
      alt={`${emp.nom} ${emp.prenom}`}
      className="w-24 h-24 md:w-32 md:h-32 object-cover rounded-full border-4 border-white shadow-lg"
    />
  ) : (
    <div className="flex items-center justify-center w-24 h-24 md:w-32 md:h-32 rounded-full border-4 border-white shadow-lg bg-gray-200">
      <User className="w-12 h-12 text-terrecuite" />
    </div>
  )}

  {isEditing && (
    <>
      <button
        type="button"
        className="absolute bottom-0 right-0 bg-white p-2 rounded-full shadow-md hover:bg-gray-100 transition"
        onClick={() => document.getElementById('fileInput').click()}
      >
        <Camera className="h-5 w-5 text-gray-700" />
      </button>
      <input
        type="file"
        id="fileInput"
        accept="image/*"
        onChange={handlePhotoSelect}
        className="hidden"
      />
    </>
  )}
</div>

            
            <div className="flex-1">
              <h1 className="text-2xl md:text-3xl font-bold text-gray-800">
                {emp.prenom} {emp.nom}
              </h1>
              <p className="text-gray-600 mt-1">ID: {emp.utilisateur_id || emp.id}</p>
              <div className="mt-3 flex flex-wrap gap-2">
                <span className="inline-flex items-center px-3 py-1 rounded-full text-xs font-medium bg-terrecuite/10 text-terrecuite">
                  <User className="h-3 w-3 mr-1" />
                  {emp.role?.nom ?? 'N/A'}
                </span>
                <span className="inline-flex items-center px-3 py-1 rounded-full text-xs font-medium bg-blue-100 text-blue-800">
                  <Users className="h-3 w-3 mr-1" />
                  {emp.module?.nom ?? 'N/A'}
                </span>
                <span className="inline-flex items-center px-3 py-1 rounded-full text-xs font-medium bg-green-100 text-green-800">
                  <FileText className="h-3 w-3 mr-1" />
                  {emp.type_contrat ?? 'N/A'}
                </span>
              </div>
            </div>
          </div>
        </div>
      </div>
  
      {/* Main Content */}
      <div className="container mx-auto px-4 py-8 grid grid-cols-1 lg:grid-cols-3 gap-6">
        {/* Personal Information */}
        <div className="bg-white rounded-xl shadow-sm overflow-hidden">
          <div className="bg-terrecuite/10 px-6 py-4 border-b border-gray-200">
            <h2 className="text-xl font-semibold text-gray-800 flex items-center">
              <User className="h-5 w-5 text-terrecuite mr-3" />
              Informations personnelles
            </h2>
          </div>
          <div className="p-6">
            <form className="space-y-4">
              {[
                { label: 'CIN', key: 'cin', type: 'text', icon: <CreditCard className="h-5 w-5 text-gray-400" /> },
                { label: 'Date de naissance', key: 'date_naissance', type: 'date', icon: <Calendar className="h-5 w-5 text-gray-400" /> },
                { label: 'Sexe', key: 'sexe', type: 'select', icon: <VenetianMask className="h-5 w-5 text-gray-400" /> },
                { label: 'Email', key: 'email', type: 'email', icon: <Mail className="h-5 w-5 text-gray-400" /> },
                { label: 'Téléphone', key: 'telephone', type: 'tel', icon: <Phone className="h-5 w-5 text-gray-400" /> },
                { label: 'Adresse', key: 'adresse', type: 'text', icon: <Home className="h-5 w-5 text-gray-400" /> },
              ].map(({ label, key, type, icon }) => (
                <div key={key} className="flex items-start">
                  <div className="mt-1 mr-3">
                    {icon}
                  </div>
                  <div className="flex-1">
                    <label className="block text-sm font-medium text-gray-700 mb-1">{label}</label>
                    {isEditing ? (
                      type === 'select' ? (
                        <select
                          name={key}
                          value={formData[key]}
                          onChange={handleChange}
                          className="w-full border border-gray-300 rounded-lg px-3 py-2 focus:ring-2 focus:ring-terrecuite focus:border-terrecuite outline-none transition"
                        >
                          <option value="">-- Choisir --</option>
                          <option value="Homme">Homme</option>
                          <option value="Femme">Femme</option>
                        </select>
                      ) : (
                        <input
                          type={type}
                          name={key}
                          value={formData[key]}
                          onChange={handleChange}
                          className="w-full border border-gray-300 rounded-lg px-3 py-2 focus:ring-2 focus:ring-terrecuite focus:border-terrecuite outline-none transition"
                        />
                      )
                    ) : (
                      <p className="text-gray-800 font-medium">{emp[key] || 'N/A'}</p>
                    )}
                  </div>
                </div>
              ))}
            </form>
          </div>
        </div>
  
        {/* Professional Information */}
        <div className="bg-white rounded-xl shadow-sm overflow-hidden">
          <div className="bg-blue-50 px-6 py-4 border-b border-gray-200">
            <h2 className="text-xl font-semibold text-gray-800 flex items-center">
              <Briefcase className="h-5 w-5 text-blue-600 mr-3" />
              Informations professionnelles
            </h2>
          </div>
          <div className="p-6">
            <form className="space-y-4">
              {[
                { label: 'Login', key: 'login', type: 'text', icon: <User className="h-5 w-5 text-gray-400" /> },
                { label: 'Date d\'embauche', key: 'date_d_embauche', type: 'date', icon: <CalendarCheck className="h-5 w-5 text-gray-400" /> },
                { label: 'Type de contrat', key: 'type_contrat', type: 'text', icon: <FileText className="h-5 w-5 text-gray-400" /> },
                { label: 'RIB', key: 'rib', type: 'text', icon: <DollarSign className="h-5 w-5 text-gray-400" /> },
                { label: 'Équipe', key: 'module_id', type: 'select', icon: <Users className="h-5 w-5 text-gray-400" /> },
              ].map(({ label, key, type, icon }) => (
                <div key={key} className="flex items-start">
                  <div className="mt-1 mr-3">
                    {icon}
                  </div>
                  <div className="flex-1">
                    <label className="block text-sm font-medium text-gray-700 mb-1">{label}</label>
                    {isEditing && type === 'select' ? (
                      <select
                        name={key}
                        value={formData[key]}
                        onChange={handleChange}
                        className="w-full border border-gray-300 rounded-lg px-3 py-2 focus:ring-2 focus:ring-blue-500 focus:border-blue-500 outline-none transition"
                      >
                        <option value="">-- Choisir équipe --</option>
                        {modulesList.map(m => (
                          <option key={m.id} value={m.id}>
                            {m.nom}
                          </option>
                        ))}
                      </select>
                    ) : isEditing ? (
                      <input
                        type={type}
                        name={key}
                        value={formData[key]}
                        onChange={handleChange}
                        className="w-full border border-gray-300 rounded-lg px-3 py-2 focus:ring-2 focus:ring-blue-500 focus:border-blue-500 outline-none transition"
                      />
                    ) : (
                      <p className="text-gray-800 font-medium">
                        {key === 'module_id' ? emp.module?.nom : emp[key] || 'N/A'}
                      </p>
                    )}
                  </div>
                </div>
              ))}
            </form>
          </div>
        </div>
  
        {/* System Metadata */}
        <div className="bg-white rounded-xl shadow-sm overflow-hidden">
          <div className="bg-gray-50 px-6 py-4 border-b border-gray-200">
            <h2 className="text-xl font-semibold text-gray-800 flex items-center">
              <Database className="h-5 w-5 text-gray-600 mr-3" />
              Métadonnées système
            </h2>
          </div>
          <div className="p-6 space-y-6">
            {[
              { label: 'Créé le', value: emp.created_at, icon: <PlusCircle className="h-5 w-5 text-gray-400" /> },
              { label: 'Mis à jour le', value: emp.updated_at, icon: <RefreshCw className="h-5 w-5 text-gray-400" /> },
              { label: 'Supprimé le', value: emp.deleted_at, icon: <Trash2 className="h-5 w-5 text-gray-400" /> },
            ].map(({ label, value, icon }) => (
              <div key={label} className="flex items-start">
                <div className="mt-1 mr-3">
                  {icon}
                </div>
                <div>
                  <p className="text-sm font-medium text-gray-500">{label}</p>
                  <p className="text-sm text-gray-800 font-medium">
                    {value ? new Date(value).toLocaleString() : 'N/A'}
                  </p>
                </div>
              </div>
            ))}
  
            {/* Additional Actions */}
            <div className="pt-4 mt-4 border-t border-gray-200">
              <h3 className="text-sm font-medium text-gray-700 mb-3 flex items-center">
                <Settings className="h-4 w-4 mr-2 text-gray-500" />
                Actions
              </h3>
              <div className="space-y-2">
<button
  onClick={() => setShowPasswordForm(true)}
  className="w-full flex items-center justify-between px-3 py-2 text-sm text-left text-gray-700 hover:bg-gray-50 rounded-lg transition"
>
  <span className="flex items-center">
    <Key className="h-4 w-4 mr-2 text-gray-500" />
    Réinitialiser le mot de passe
  </span>
  <ChevronRight className="h-4 w-4 text-gray-400" />
</button>

{/* Dans ton bloc Actions, juste à la place de l’ancien {showPasswordForm && (…) } */}
{showPasswordForm && (
  <div className="mt-4 space-y-4">
    {[
      {
        label: 'Mot de passe actuel',
        key: 'current_password',
        type: 'password',
        icon: <Key className="h-5 w-5 text-gray-400" />
      },
      {
        label: 'Nouveau mot de passe',
        key: 'new_password',
        type: 'password',
        icon: <Lock className="h-5 w-5 text-gray-400" />
      },
      {
        label: 'Confirmation du mot de passe',
        key: 'confirm_password',
        type: 'password',
        icon: <Check className="h-5 w-5 text-gray-400" />
      }
    ].map(({ label, key, type, icon }) => (
      <div key={key} className="flex items-start">
        <div className="mt-1 mr-3">{icon}</div>
        <div className="flex-1">
          <label className="block text-sm font-medium text-gray-700 mb-1">
            {label}
          </label>
          <input
            type={type}
            name={key}
            value={passwordData[key]}
            onChange={handlePasswordChange}
            className="w-full border border-gray-300 rounded-lg px-3 py-2 focus:ring-2 focus:ring-terrecuite focus:border-terrecuite outline-none transition"
          />
        </div>
      </div>
    ))}

    <div className="flex justify-end space-x-2">
      <button
        onClick={() => setShowPasswordForm(false)}
        className="px-4 py-2 bg-gray-100 rounded-lg hover:bg-gray-200 transition"
      >
        Annuler
      </button>
      <button
        onClick={handlePasswordSave}
        className="px-4 py-2 bg-green-600 text-white rounded-lg hover:bg-green-700 transition"
      >
        Valider
      </button>
    </div>
  </div>
)}
<button
  onClick={handleForgotPassword}
  className="w-full flex items-center justify-between px-3 py-2 text-sm text-left text-orange-600 hover:bg-orange-50 rounded-lg transition"
>
  <span className="flex items-center">
    <Key className="h-4 w-4 mr-2 text-orange-500" />
    Mot de passe oublié
  </span>
  <ChevronRight className="h-4 w-4 text-orange-400" />
</button>



                <button className="w-full flex items-center justify-between px-3 py-2 text-sm text-left text-red-600 hover:bg-red-50 rounded-lg transition">
                  <span className="flex items-center">
                    <Trash2 className="h-4 w-4 mr-2 text-red-500" />
                    Supprimer le compte
                  </span>
                  <ChevronRight className="h-4 w-4 text-red-400" />
                </button>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}
